import { Flex } from '@chakra-ui/layout';
import { Tag, TagLabel } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { EditableTitle } from '../../../../../common/Inputs';
import { getFixedFormValues } from './dataMappings/getFormValues';
import { setFormValues } from './dataMappings/setFormValues';
import { usePricingOptionDiffResult } from '~/core/routes/settings/implementations/[implementationId]/facilities/[facilityId]/pricing-options/hooks';
import { FixedPricingOptionFormData } from '~/core/routes/settings/implementations/[implementationId]/facilities/[facilityId]/pricing-options/types';
import { AutoSave } from '~/core/routes/settings/implementations/common/AutoSave';
import { useGetCreditAgreementLazy } from '~/core/routes/settings/implementations/common/CreditAgreementProvider/CreditAgreementProvider';
import {
  TextInput,
  WholePageDiffOutline,
} from '~/core/routes/settings/implementations/common/DiffInputs';
import { Typography } from '~/packages/common-frontend/components/Typography';

export const FixedRateView = ({
  pricingOptionId,
}: {
  pricingOptionId: string;
}) => {
  const getCreditAgreementOrThrow = useGetCreditAgreementLazy();

  const form = useForm<FixedPricingOptionFormData>({
    defaultValues: {
      wipForm: getFixedFormValues(getCreditAgreementOrThrow(), pricingOptionId),
    },
    mode: 'onTouched',
  });

  const diffValues = usePricingOptionDiffResult(pricingOptionId);

  useEffect(() => {
    const type = diffValues?.previousPricingOptionFormData?.type;
    if (type === 'fixed' || type === undefined) {
      form.setValue('diffForm', diffValues?.previousPricingOptionFormData);
    }
  }, [form, diffValues]);

  return (
    <FormProvider {...form}>
      <AutoSave<FixedPricingOptionFormData> onSave={setFormValues} />
      <WholePageDiffOutline diff={diffValues?.diffResult}>
        <form>
          <Flex direction="column">
            <Flex gap="1.5rem" direction="column">
              <Flex gap="1.5rem" alignItems="center">
                <EditableTitle<FixedPricingOptionFormData>
                  name="wipForm.name"
                  required
                />
                <Tag variant="solid-muted" colorScheme="blue">
                  <TagLabel>Fixed</TagLabel>
                </Tag>
              </Flex>
              <Typography variant="base-muted">
                Margin can be added in Commitments. Select &apos;Review
                Changes&apos; to submit for approval.
              </Typography>
            </Flex>
            <Flex my="2rem" gap="1rem" direction="column">
              <TextInput<FixedPricingOptionFormData>
                name="wipForm.value"
                diffName="diffForm.value"
                label="Interest Rate"
                mask="percentage"
                placeholder="%"
                helperText="Specifies the fixed base rate used to determine the interest rate for the loan."
                required
              />
            </Flex>
          </Flex>
        </form>
      </WholePageDiffOutline>
    </FormProvider>
  );
};
